/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import { Table, Form, Button, Collapse, Image } from "react-bootstrap";
import { WebSocketContext } from "../../../App";
import wsSend_request from "../../../Api/ws/ws_request";
import { useSelector, useDispatch } from "react-redux";
import MoreIcon from "../../../assets/img/more_options.png";
import CommonDateTime from "../../Common/CommonDateTime";
import AmountNumberFormat from "../../Common/AmountNumberFormat";
import { Link, useParams, useNavigate } from "react-router-dom";
import { PO_POSTING_URL } from "../../Shared/constant";
import {
  GetOrderReportDetails,
  StartMainCommonLoader,
  getErpAcountListSOrder,
} from "../../../redux/actions/adminActions";
import EmptySpaceFieldValid from "../../Common/EmptySpaceFieldValid";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CancelOrder from "../../Common/CancelOrder";
import OrderPause from "./OrderPause";
import CommonLoader from "../../Common/CommonLoader";
import CommonewModel from "../../Common/CommonewModel";
import CommonScrollBar from "../../Common/CommonScrollBar";

const ApprovalOrders = (props) => {
  const { roomId } = useParams();
  const Navigate = useNavigate();
  const Dispatch = useDispatch();
  const { websocket } = useContext(WebSocketContext);
  const {
    device_id,
    ClearFormSet,
    OrderReportDetails,
    erpAccountListSOrder,
    commonMainLoader,
    selfInfo,
  } = useSelector((state) => state.adminReducers);
  const PermissionsAccess = selfInfo?.user?.permissions_access;
  const [activeTableDetails, setActiveTableDetails] = useState("");
  const exceptThisCostSymbols = ["e", "E", "+", "-", "."];
  const [OrderPriority, setOrderPriority] = useState("");
  const [errorOrderPriority, setErrorOrderPriority] = useState("");
  const [showModalNew, setShowModalNew] = useState({
    open: false,
    title: "",
    subtitle: "",
    modalType: "",
    button: "",
    Data: {},
  });

  useEffect(() => {
    if (roomId) {
      Dispatch(
        StartMainCommonLoader({
          url: "order_detail",
          loader: true,
        }),
      );
      let param = {
        transmit: "broadcast",
        url: "order_detail",
        request: {
          order_id: roomId,
          is_so_approved: true,
          is_weight: true,
        },
        DeviceId: device_id,
      };
      wsSend_request(websocket, param);
    }
  }, [websocket, roomId]);

  useEffect(() => {
    if (
      Object?.keys(OrderReportDetails)?.length > 0 &&
      OrderReportDetails?.order?.order_type === "FO"
    ) {
      let param = {
        transmit: "broadcast",
        url: "erp_account",
        request: {
          search: "",
          limit: 5000,
          page_no: 1,
          from_date: null,
          to_date: null,
          franchise_id: OrderReportDetails?.order?.billing_id,
          order_by: "-updated_at",
        },
        module_name: "erp-account-so-creation",
        DeviceId: device_id,
      };
      wsSend_request(websocket, param);
    }
  }, [OrderReportDetails]);

  // show more user details
  const ViewMoreDetails = (id) => {
    setActiveTableDetails(id);
  };

  // hide more user details
  const ElseMoreDetails = () => {
    setActiveTableDetails("");
  };

  // select order priority
  const selectOrderPriority = (value) => {
    if (value !== "") {
      setOrderPriority(value);
      setErrorOrderPriority("");
    } else {
      setOrderPriority("");
      setErrorOrderPriority("Please select order priority");
    }
  };

  // get total balance and Credit Limit
  const GetCurrentOrderRate = (current) => {
    const getCurrentFranchise = current?.order?.billing;
    return {
      available_balance: parseFloat(
        getCurrentFranchise?.erp_credit_limit -
          getCurrentFranchise?.erp_outstanding,
      ),
      erp_credit_limit: getCurrentFranchise?.erp_credit_limit,
      erp_outstanding: getCurrentFranchise?.erp_outstanding,
    };
  };

  const UpdateOrderReportDetails = OrderReportDetails?.order_items_list?.map(
    (elm) => {
      return {
        order: elm,
        id: elm?.id,
        QntMain: parseFloat(elm?.qty - elm?.partial_qty).toString(),
      };
    },
  );

  const [MainArray, setMainArray] = useState([]);

  useEffect(() => {
    if (UpdateOrderReportDetails !== undefined) {
      setMainArray(UpdateOrderReportDetails);
    }
  }, [OrderReportDetails]);

  const GetOrderQuantity = (value, MainValue, data) => {
    const balanceQty =
      parseInt(data?.qty || 0) - parseInt(data?.partial_qty || 0);

    const isBasketProduct = !!(
      data?.product?.basket_height ||
      data?.product?.basket_length ||
      data?.product?.basket_width ||
      data?.product?.basket_weight
    );

    const isEven = (n) => Number(n) % 2 === 0;

    const basketQtyValid = !isBasketProduct || isEven(value);
    const basketQtyValidSecond = !isBasketProduct || isEven(MainValue);

    if (!basketQtyValid) {
      toast.error(
        "For this product, quantity must be in even numbers.",
      );
      return;
    }

    if (!basketQtyValidSecond) {
      toast.error(
        "For this product, quantity must be in even numbers.",
      );
      return;
    }

    const QauntityValid = value <= balanceQty;
    const QauntityValidSecond = MainValue <= balanceQty;

    if (QauntityValid) {
      const UpdatedArray = MainArray?.map((elm) => {
        if (elm?.id === data?.id) {
          return {
            ...elm,
            QntMain: value,
          };
        }
        return elm;
      });
      setMainArray(UpdatedArray);
    } else {
      toast.error(`Balance Qty should not be more than ${balanceQty}`);
    }

    if (!QauntityValidSecond) {
      toast.error(`Balance Qty should not be more than ${balanceQty}`);
    }
  };

  // GET CURRENT FRANCHISE AVAILABLE BALANCE SHOULD BE GREATER THAN THE TOTAL ORDER AMOUNT
  const GetCurrentTotalOrderAmount =
    OrderReportDetails?.order_items_list?.reduce((total, elm) => {
      return total + elm?.sub_total;
    }, 0) <= GetCurrentOrderRate(OrderReportDetails)?.available_balance;

  // SO APPROVAL ORDER FUNCTION
  const submitObjectArray = MainArray?.map((elm) => ({
    qty: elm?.QntMain,
    order_items_id: elm?.order?.id,
  }))?.filter((elm) => elm?.qty !== "" && elm?.qty > 0);

  const OrderApproval = () => {
    const is90OS =
      parseInt(erpAccountListSOrder?.list[0]?.range4) > 0 ||
      parseInt(erpAccountListSOrder?.list[0]?.range5) > 0;
    const isFO = OrderReportDetails?.order?.order_type === "FO";
    const isAO = OrderReportDetails?.order?.order_type === "AO";
    const hasQty =
      submitObjectArray &&
      submitObjectArray.filter((elm) => elm?.qty !== "").length > 0;
    const showModal = (desc) =>
      setShowModalNew({
        ...showModalNew,
        open: true,
        title: "Exceeded Balance Approval",
        subtitle: "Order-Approval-Unavailable-Balance",
        modalType: "Order-Approval-Unavailable-Balance",
        description: desc,
        button: "Proceed",
        function: APICallingSoApproval,
        Data: {},
      });

    if (isAO && submitObjectArray !== undefined && OrderPriority !== "") {
      if (hasQty) {
        if (isFO) {
          let desc = "";
          if (GetCurrentOrderRate(OrderReportDetails)?.available_balance < 0) {
            desc =
              "The credit limit is completely utilised." +
              (is90OS
                ? " <span class='so_creation_erp_account'> Attention: Dealer under category of 90+OS.</span>"
                : "");
          } else if (GetCurrentTotalOrderAmount) {
            desc =
              "Order value is under the credit limit." +
              (is90OS
                ? " <span class='so_creation_erp_account'> Attention: Dealer under category of 90+OS.</span>"
                : "");
          } else {
            desc =
              "Order value is exceeding the available credit limit. Please approve to proceed further and note that this deviation is logged in the systems." +
              (is90OS
                ? " <span class='so_creation_erp_account'> Attention: Dealer under category of 90+OS.</span>"
                : "");
          }
          showModal(desc);
        } else {
          APICallingSoApproval();
        }
      } else {
        toast.error("Please enter balance Qty.");
      }
    } else if (!isAO) {
      if (hasQty) {
        if (isFO) {
          let desc = "";
          if (GetCurrentOrderRate(OrderReportDetails)?.available_balance < 0) {
            desc =
              "The credit limit is completely utilised." +
              (is90OS
                ? " <span class='so_creation_erp_account'> Attention: Dealer under category of 90+OS.</span>"
                : "");
          } else if (GetCurrentTotalOrderAmount) {
            desc =
              "Order value is under the credit limit." +
              (is90OS
                ? " <span class='so_creation_erp_account'> Attention: Dealer under category of 90+OS.</span>"
                : "");
          } else {
            desc =
              "Order value is exceeding the available credit limit. Please approve to proceed further and note that this deviation is logged in the systems." +
              (is90OS
                ? " <span class='so_creation_erp_account'> Attention: Dealer under category of 90+OS.</span>"
                : "");
          }
          showModal(desc);
        } else {
          APICallingSoApproval();
        }
      } else {
        toast.error("Please enter balance Qty.");
      }
    } else {
      setErrorOrderPriority("Please select order priority");
    }
  };

  // SO APPROVAL API CALL
  const APICallingSoApproval = (data) => {
    if (OrderReportDetails?.order?.order_type === "AO") {
      if (submitObjectArray !== undefined && OrderPriority !== "") {
        if (
          submitObjectArray &&
          submitObjectArray?.filter((elm) => elm?.qty !== "")?.length > 0
        ) {
          Dispatch(
            StartMainCommonLoader({
              url: "so_approval",
              loader: true,
            }),
          );

          let param = {
            transmit: "broadcast",
            url: "so_approval",
            request: {
              order_id: roomId,
              items: submitObjectArray,
              order_priority: OrderPriority,
            },
            DeviceId: device_id,
          };
          if (OrderReportDetails?.order?.order_type === "FO") {
            param.request.available_balance =
              GetCurrentOrderRate(OrderReportDetails)?.available_balance;
            param.request.is_breached = !GetCurrentTotalOrderAmount;
            param.request.overdue_90_plus_days =
              erpAccountListSOrder?.list[0]?.range4;
          }
          wsSend_request(websocket, param);
        } else {
          toast.error(`Please enter balance Qty.`);
        }
      } else {
        setErrorOrderPriority("Please select order priority");
      }
    } else {
      if (
        submitObjectArray &&
        submitObjectArray?.filter((elm) => elm?.qty !== "")?.length > 0
      ) {
        Dispatch(
          StartMainCommonLoader({
            url: "so_approval",
            loader: true,
          }),
        );

        let param = {
          transmit: "broadcast",
          url: "so_approval",
          request: {
            order_id: roomId,
            items: submitObjectArray,
            order_priority: OrderPriority,
          },
          DeviceId: device_id,
        };
        if (OrderReportDetails?.order?.order_type === "FO") {
          param.request.available_balance =
            GetCurrentOrderRate(OrderReportDetails)?.available_balance;
          param.request.is_breached = !GetCurrentTotalOrderAmount;
          param.request.overdue_90_plus_days =
            erpAccountListSOrder?.list[0]?.range4;
        }
        wsSend_request(websocket, param);
      } else {
        toast.error(`Please enter balance Qty.`);
      }
    }
  };

  useEffect(() => {
    if (ClearFormSet?.action === 200) {
      Navigate(PO_POSTING_URL);
      Dispatch(getErpAcountListSOrder({}));
    }
  }, [ClearFormSet]);

  document.addEventListener("wheel", function (event) {
    if (
      document.activeElement.type === "number" &&
      document.activeElement.classList.contains("qntyClass")
    ) {
      document.activeElement.blur();
    }
  });

  // show last three orders
  const CheckStockLevelOrders = (orders) => {
    setShowModalNew({
      ...showModalNew,
      title: orders?.product_name,
      subtitle: "Check Stock Level",
      modalType: "form",
      open: !showModalNew?.open,
      button: "",
      Data: orders?.product_id,
    });
    Dispatch(
      StartMainCommonLoader({
        url: "store_level_list",
        loader: true,
      }),
    );
  };

  function displayZeroIfNegative(number) {
    if (!isNaN(number)) {
      if (number < 0) {
        return 0;
      } else {
        return number;
      }
    } else {
      return 0;
    }
  }

  const GetPriorityName = (current_order, list, qty) => {
    const { balance_qty } =
      current_order?.stock_levels?.length === 0
        ? {}
        : current_order?.stock_levels[0];
    const invoiceable = displayZeroIfNegative(balance_qty);

    if (current_order?.warehouse_priority === "1") {
      if (invoiceable >= qty) {
        return "warehousePriorityCl";
      } else {
        return "warehousePrioritydanger";
      }
    } else if (current_order?.warehouse_priority === "2") {
      const invoiceablePriority1 = displayZeroIfNegative(
        list[0]?.stock_levels[0]?.balance_qty,
      );

      if (invoiceable >= qty) {
        return invoiceablePriority1 >= qty
          ? "warehousePrioritydanger"
          : "warehousePriorityCl";
      } else {
        return "warehousePrioritydanger";
      }
    } else if (current_order?.warehouse_priority === "3") {
      const invoiceablePriority1 = displayZeroIfNegative(
        list[0]?.stock_levels[0]?.balance_qty,
      );
      const invoiceablePriority2 = displayZeroIfNegative(
        list[1]?.stock_levels[0]?.balance_qty,
      );

      if (invoiceable >= qty) {
        return invoiceablePriority1 >= qty
          ? "warehousePrioritydanger"
          : invoiceablePriority2 >= qty
            ? "warehousePrioritydanger"
            : "warehousePriorityCl";
      } else {
        return "warehousePrioritydanger";
      }
    } else if (current_order?.warehouse_priority === "4") {
      const invoiceablePriority1 = displayZeroIfNegative(
        list[0]?.stock_levels[0]?.balance_qty,
      );
      const invoiceablePriority2 = displayZeroIfNegative(
        list[1]?.stock_levels[0]?.balance_qty,
      );
      const invoiceablePriority3 = displayZeroIfNegative(
        list[2]?.stock_levels[0]?.balance_qty,
      );

      if (invoiceable >= qty) {
        return invoiceablePriority1 >= qty
          ? "warehousePrioritydanger"
          : invoiceablePriority2 >= qty
            ? "warehousePrioritydanger"
            : invoiceablePriority3 >= qty
              ? "warehousePrioritydanger"
              : "warehousePriorityCl";
      } else {
        return "warehousePrioritydanger";
      }
    }
  };

  return (
    <section className="Main_section">
      <div className="MainHeader">
        <Link
          to={PO_POSTING_URL}
          onClick={() => Dispatch(GetOrderReportDetails({}))}
          className="btn btn-link backbtn"
        >
          <i className="bi bi-arrow-left-short"></i> Back
        </Link>
      </div>
      {OrderReportDetails !== undefined &&
      Object.keys(OrderReportDetails)?.length > 0 ? (
        <>
          <div
            className="filtr_Form"
            style={{ paddingBottom: "10px", borderBottom: "1px solid #eee" }}
          >
            <div className="formloginset formloginsetStaticData">
              <div className="row">
                {OrderReportDetails?.order?.order_type !== "CO" && (
                  <div className="col-md-3">
                    <Form.Group className="mb-3 ">
                      <Form.Label>Franchise Name</Form.Label>
                      <div className="defaultvalueField">
                        {OrderReportDetails?.order?.customer_name}
                      </div>
                    </Form.Group>
                  </div>
                )}
                <div className="col-md-3">
                  <Form.Group className="mb-3 ">
                    <Form.Label>Request No</Form.Label>
                    <div className="defaultvalueField">
                      {OrderReportDetails?.order?.order_code}
                    </div>
                  </Form.Group>
                </div>
                <div className="col-md-3">
                  <Form.Group className="mb-3 ">
                    <Form.Label>Request Date</Form.Label>
                    <div className="defaultvalueField">
                      {CommonDateTime(
                        OrderReportDetails?.order?.created_at,
                        "LL",
                        "show",
                      )}
                    </div>
                  </Form.Group>
                </div>
                <div className="col-md-3">
                  <Form.Group className="mb-3 ">
                    <Form.Label>Total Qty</Form.Label>
                    <div className="defaultvalueField">
                      {OrderReportDetails?.order?.qty}
                    </div>
                  </Form.Group>
                </div>
                {OrderReportDetails?.order?.order_type === "AO" &&
                  (OrderReportDetails?.order?.order_source ===
                    "AMAZON_IN_API" ||
                    OrderReportDetails?.order?.order_source === "AMAZON") && (
                    <div className="col-md-3">
                      <Form.Group className="mb-3 ">
                        <Form.Label>
                          Select Order Priority{" "}
                          <span className="mendatory_star">*</span>
                        </Form.Label>
                        <select
                          className="form-control"
                          value={OrderPriority}
                          onChange={(e) =>
                            selectOrderPriority(e?.target?.value)
                          }
                        >
                          <option value="">Select Order Priority</option>
                          <option value="Amazon Prime">Prime </option>
                          <option value="Amazon">Non Prime</option>
                        </select>
                        {errorOrderPriority && (
                          <span className="error_medotory">
                            {errorOrderPriority}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  )}
                <div className="col-md-3">
                  <Form.Group>
                    <Form.Label>State:</Form.Label>
                    <div className="defaultvalueField">
                      {OrderReportDetails?.order?.state?.state_name}
                    </div>
                  </Form.Group>
                </div>
                {OrderReportDetails?.order?.order_type === "FO" && (
                  <>
                    <div className="col-md-3">
                      <Form.Group>
                        <Form.Label>Credit Limit:</Form.Label>
                        <div className="defaultvalueField highlighted_defaultvalueField">
                          {AmountNumberFormat(
                            GetCurrentOrderRate(OrderReportDetails)
                              ?.erp_credit_limit,
                          )}
                        </div>
                      </Form.Group>
                    </div>
                    <div className="col-md-3">
                      <Form.Group>
                        <Form.Label>Outstanding:</Form.Label>
                        <div className="defaultvalueField highlighted_defaultvalueField">
                          {AmountNumberFormat(
                            GetCurrentOrderRate(OrderReportDetails)
                              ?.erp_outstanding,
                          )}
                        </div>
                      </Form.Group>
                    </div>
                    <div className="col-md-3">
                      <Form.Group>
                        <Form.Label>Available Balance:</Form.Label>
                        <div className="defaultvalueField highlighted_defaultvalueField">
                          {AmountNumberFormat(
                            GetCurrentOrderRate(OrderReportDetails)
                              ?.available_balance,
                          )}
                        </div>
                      </Form.Group>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="tableView gstreporttableadded">
            <CommonScrollBar
              className={"ScrollbarsSidebar ScrollbarsSidebarHorizontal"}
              height={{
                height:
                  OrderReportDetails?.order?.order_type === "AO" ||
                  OrderReportDetails?.order?.order_type === "FO"
                    ? "calc(100vh - 298px)"
                    : "calc(100vh - 236px)",
              }}
            >
              <Table id="stock_level_so_approval">
                <thead>
                  <tr>
                    <th></th>
                    <th>SNo</th>
                    <th>Code</th>
                    <th>Product Name</th>
                    <th>Amount</th>
                    <th>Total Qty</th>
                    <th>Appr. Qty</th>
                    <th>Qty</th>
                    {OrderReportDetails?.order_items_list[0]?.is_bike &&
                      OrderReportDetails?.order_items_list?.length > 0 &&
                      OrderReportDetails?.order_items_list[0].priority_warehouses?.map(
                        (elmx, index) => {
                          return (
                            <th
                              key={index}
                              style={{
                                whiteSpace: "pre-line",
                                borderLeftWidth: "1px",
                                borderColor: "#ddd",
                                textAlign: "center",
                              }}
                            >
                              {elmx?.warehouse_name}
                            </th>
                          );
                        },
                      )}
                  </tr>
                </thead>
                <tbody>
                  {OrderReportDetails?.order_items_list?.map((elm, index) => {
                    return (
                      <React.Fragment key={index}>
                        <tr>
                          <td style={{ width: "10px" }}>
                            <button
                              className={
                                activeTableDetails === elm?.id
                                  ? "btn actionbtn active"
                                  : "btn actionbtn"
                              }
                              onClick={() =>
                                activeTableDetails === elm?.id
                                  ? ElseMoreDetails()
                                  : ViewMoreDetails(elm?.id)
                              }
                              aria-controls="example-collapse-text"
                              aria-expanded={
                                activeTableDetails === elm?.id ? true : false
                              }
                            >
                              <Image src={MoreIcon} alt="more icon" />
                            </button>
                          </td>
                          <td>{index + 1}</td>
                          <td>{elm?.product_code}</td>
                          <td>{elm?.product_name}</td>
                          <td>{elm?.sub_total}</td>
                          <td>{elm?.qty}</td>
                          <td>{elm?.partial_qty}</td>
                          <td>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-start",
                                columnGap: "10px",
                              }}
                            >
                              {MainArray?.map((elmz, index) => {
                                if (elmz?.id === elm?.id) {
                                  return (
                                    <input
                                      type="number"
                                      className="form-control qntyClass"
                                      value={elmz?.QntMain}
                                      onChange={(e) =>
                                        GetOrderQuantity(
                                          e?.target?.value <=
                                            parseInt(elm?.qty) -
                                              parseInt(elm?.partial_qty)
                                            ? e?.target?.value.replace(/^0/, "")
                                            : 0,
                                          e?.target?.value.replace(/^0/, ""),
                                          elm,
                                        )
                                      }
                                      readOnly={
                                        !(
                                          selfInfo?.user?.user_type ===
                                            "super_admin" ||
                                          PermissionsAccess?.OrderManagement[2]
                                            ?.Edit
                                        )
                                      }
                                      onKeyDown={(e) => {
                                        EmptySpaceFieldValid(e);
                                        exceptThisCostSymbols.includes(e.key) &&
                                          e.preventDefault();
                                      }}
                                      maxLength={
                                        elmz?.QntMain <=
                                        parseInt(elm?.qty) -
                                          parseInt(elm?.partial_qty)
                                      }
                                      key={index}
                                      disabled={
                                        OrderReportDetails?.order
                                          ?.erp_bundle_id !== null
                                      }
                                      min="1"
                                      max="10"
                                    />
                                  );
                                }
                              })}
                              <button
                                className="btn btn-link"
                                onClick={() => CheckStockLevelOrders(elm)}
                              >
                                Check Stock
                              </button>
                            </div>
                          </td>

                          {elm?.is_bike &&
                            elm?.priority_warehouses?.map(
                              (elmx, index, dataArray) => {
                                const { balance_qty } =
                                  elmx?.stock_levels?.length === 0
                                    ? {}
                                    : elmx?.stock_levels[0];
                                const invoiceable =
                                  displayZeroIfNegative(balance_qty);

                                return (
                                  <td
                                    style={{
                                      borderLeftWidth: "1px",
                                      borderColor: "#ddd",
                                      textAlign: "center",
                                    }}
                                    className={GetPriorityName(
                                      elmx,
                                      dataArray,
                                      elm?.qty,
                                    )}
                                    key={index}
                                  >
                                    {invoiceable}
                                  </td>
                                );
                              },
                            )}
                        </tr>
                        <Collapse
                          in={activeTableDetails === elm?.id ? true : false}
                        >
                          <tr
                            className="tablecollapsewraps"
                            id={"tablecollpase" + elm?.id}
                          >
                            <td colSpan="12" style={{ padding: "0px" }}>
                              <Table className="table">
                                <tbody>
                                  <tr>
                                    <th style={{ width: "20%" }}>
                                      Unit Amount
                                    </th>
                                    <td>{parseInt(elm?.price).toFixed(2)}</td>
                                  </tr>
                                  <tr>
                                    <th style={{ width: "20%" }}>Tax Amount</th>
                                    <td>{elm?.sub_gst}</td>
                                  </tr>
                                </tbody>
                              </Table>
                            </td>
                          </tr>
                        </Collapse>
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </Table>
              <div className="col-md-12 pt-3" style={{ textAlign: "right" }}>
                {selfInfo?.user?.user_type === "super_admin" ||
                PermissionsAccess?.OrderManagement[2]?.Edit ? (
                  <Button
                    className="formbtn mt-0 me-2"
                    disabled={
                      (commonMainLoader?.url === "so_approval" &&
                        commonMainLoader?.loader) ||
                      submitObjectArray?.length === 0
                    }
                    onClick={() => OrderApproval()}
                    style={{ width: "auto" }}
                    variant="primary"
                  >
                    Submit
                  </Button>
                ) : (
                  <></>
                )}
                <OrderPause OrderReportDetails={OrderReportDetails} />
                <CancelOrder
                  className={"cancel-reset-Btn cancel-reset-Btn-New"}
                  data={OrderReportDetails}
                />
              </div>
            </CommonScrollBar>
          </div>
        </>
      ) : (
        <>Please Wait...</>
      )}

      {(commonMainLoader?.url === "so_approval" ||
        commonMainLoader?.url === "order_detail") &&
        commonMainLoader?.loader && <CommonLoader />}

      {showModalNew?.open && (
        <CommonewModel
          setShowModalNew={setShowModalNew}
          showModalNew={showModalNew}
        />
      )}
    </section>
  );
};

export default ApprovalOrders;